module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedExtraBold.c9785ce.woff";